module.exports = __webpack_public_path__ + "img/ib.00e46cac.png";